import { render, staticRenderFns } from "./OmxSidebar.vue?vue&type=template&id=86d3e6d2&scoped=true"
import script from "./OmxSidebar.vue?vue&type=script&lang=js"
export * from "./OmxSidebar.vue?vue&type=script&lang=js"
import style0 from "./OmxSidebar.vue?vue&type=style&index=0&id=86d3e6d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d3e6d2",
  null
  
)

export default component.exports